export default "__VITE_ASSET__BwMFANd9__"